import React from "react";
import { Button } from "antd";
import { Link, useLocation } from "react-router-dom";
import { Authority, ICurrentUser } from "@dataone/lib";
import {
  CallIcon,
  LockIcon,
  ProfileInfoIcon,
  SubscriptionSettingsIcon,
} from "@dataone/icons";
import {
  ProfileTheme_1Icon,
  ProfileTheme_2Icon,
  ProfileTheme_3Icon,
  ProfileTheme_4Icon,
  ProfileTheme_5Icon,
} from "@dataone/icons";
import styled from "styled-components";
import GuestView from "./GuestView";

interface ProfileHeaderProps {
  user: ICurrentUser;
}

const ProfileHeader = ({ user }: ProfileHeaderProps) => {
  const { pathname } = useLocation();

  interface ProfileIcons {
    [key: string]: JSX.Element;
  }

  const profileIcons: ProfileIcons = {
    "1": <ProfileTheme_1Icon />,
    "2": <ProfileTheme_2Icon />,
    "3": <ProfileTheme_3Icon />,
    "4": <ProfileTheme_4Icon />,
    "5": <ProfileTheme_5Icon />,
  };

  return (
    <>
      <StyledProfileHeader>
        <StyledHeaderAvatar>
          {profileIcons[user.avatar as keyof ProfileIcons]}
        </StyledHeaderAvatar>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <StyledUserInfo>
            <StyledUserName>
              {user.firstName} {user.lastName}
            </StyledUserName>
          </StyledUserInfo>
          <NavigationButton as={Link} to="/profile" currentPath={pathname}>
            <ProfileInfoIcon /> Profile info
          </NavigationButton>
          <NavigationButton
            as={Link}
            to="/profile/password-settings"
            currentPath={pathname}
          >
            <LockIcon /> Password Settings
          </NavigationButton>
          {/* {user?.groups["0"] !== Authority.OG_ADMIN && (
            <NavigationButton
              as={Link}
              to="/profile/phone-verification"
              currentPath={pathname}
            >
              <CallIcon /> Phone Num Settings
            </NavigationButton>
          )} */}
          {user?.groups["0"] !== Authority.OG_ADMIN &&
            user?.groups["0"] !== Authority.OG_GUEST && (
              <NavigationButton
                as={Link}
                to="/profile/subscription-settings"
                currentPath={pathname}
              >
                <SubscriptionSettingsIcon /> Subscription Settings
              </NavigationButton>
            )}
          {user?.groups["0"] === Authority.OG_GUEST && (
            <>
              <GuestView />
            </>
          )}
        </div>
      </StyledProfileHeader>
    </>
  );
};

const StyledProfileHeader = styled.div`
  height: 670px;
  position: relative;
  min-width: 330px;
  border-radius: 30px;
  border-top: 5px solid #4974f6;
  border-bottom: 5px solid #eff1fd;
  background: linear-gradient(
    180deg,
    #eff1fd 0%,
    rgba(239, 241, 253, 0) 109.03%
  );
  text-align: center;
`;

const StyledHeaderAvatar = styled.div`
  margin-top: 15%;
  font-size: 100px;
`;

const StyledUserInfo = styled.div`
  margin-top: 10px;
  margin-bottom: 50px;
`;

const StyledUserName = styled.h1`
  color: #040726;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 5px;
  max-width: 100px;
  margin: auto;
  overflow: auto;
  scrollbar-width: none;
`;

interface NavigationButtonProps {
  to: string;
  currentPath: string;
}

const NavigationButton = styled(Button)<NavigationButtonProps>`
  font-weight: 500;
  border-radius: 30px;
  background: ${(props) =>
    props.to === props.currentPath ? "#4974f6" : "#fff"};
  color: ${(props) => (props.to === props.currentPath ? "#fff" : "#4974f6")};
  border: none;
  width: 80%;
  height: 35px;
  padding: 0px !important;
  margin: 10px;
  display: flex;
  align-items: center;
  border-bottom: solid;
  &:hover {
    background: #4974f6 !important;
    color: #fff !important;
  }
  svg {
    margin-left: 40px;
    margin-right: 10px;
  }
`;

export default ProfileHeader;
